@if (control) {
  <div
    class="form-group">
    <label id="{{id}}_label"
      for='{{id}}_input'
      [ngClass]="{'visually-hidden' : !label }">
      @if (label) {
        <span>
          {{ label | translate }}
          @if (required) {
            <a>*</a>
          }
        </span>
      } @else {
        Bitte wählen Sie einen Wert aus
      }
      @if (hinweis) {
        <wba-fragezeichen
          [label]="label"
          [dataTarget]="hinweis?.target"
          [dataModal]="hinweis?.modal"
          id="{{id}}_fragezeichen"
          smaller="true"/>
      }
    </label>
    <div class="input-and-ul-group">
      <input #input
        id="{{id}}_input"
        [attr.aria-required]="required"
        [type]="inputType"
        [pattern]="pattern"
        class='form-control'
        [ngClass]="{'ba-error': isInvalid}"
        [attr.data-has-error]="isInvalid"
        [attr.data-error-message]="control.errors?.message"
        [name]='name'
        (focus)="onFocus()"
        [attr.maxlength]="maxLength"
        [placeholder]='placeholder'
        (keydown)="onKeydown($event)"
        [attr.aria-label]='label'
        [attr.aria-invalid]="isInvalid"
        [(ngModel)]="value">
      @if (isInvalid) {
        <wba-error-message
          _id="{{id}}"
          [control]="control"/>
      }
      @if (suggestedItems.length > 0) {
        <datalist
          #listElement
          id="suggestedItems"
          [class.active]="showSuggestedItems && (suggestedItems | geofilter:input.value).length !== 0"
          (keydown)="onKeydown($event)"
          class="geo-datalist-wrapper"
          tabindex="-1">
          @for (item of suggestedItems | geofilter:input.value; track item; let i = $index) {
            <option
              [id]="id + '_option_' + i"
              class="geo-selectable"
              (click)="setSuggestedItem(item)"
              (keydown.enter)="setSuggestedItem(item)"
              (keydown.space)="setSuggestedItem(item)"
            >{{item}}</option>
          }
        </datalist>
      }
    </div>
  </div>
}
